var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.633,
    height: 88.319,
    viewBox: "0 0 103.633 88.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 103.633,
    height: 88.319,
    fill: "#d9000d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10510",
    "data-name": "Group 10510",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10351",
    "data-name": "Group 10351",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27730",
    "data-name": "Path 27730",
    d: "M13.738,21.916H36.073V1.963A1.963,1.963,0,0,1,38.036,0h8.895L91.386,3.394a1.961,1.961,0,0,1,1.8,1.963V18.839A1.963,1.963,0,0,1,91.221,20.8H88.829v1.34a9.4,9.4,0,1,1-11.365,9.177,1.963,1.963,0,1,1,3.925,0,5.478,5.478,0,1,0,5.477-5.477A1.957,1.957,0,0,1,84.9,23.879V20.8H82.431a1.963,1.963,0,0,1-1.963-1.963V12.072H48.679V57.856H101.67a1.963,1.963,0,0,1,1.963,1.963v14.72A1.963,1.963,0,0,1,101.67,76.5H94.952a12.306,12.306,0,0,1-24.593,0H46.98a12.3,12.3,0,0,1-24.583,0H1.963A1.963,1.963,0,0,1,0,74.539V37.617c0-8.649,6.257-15.7,13.738-15.7m0,3.925c-5.4,0-9.813,5.283-9.813,11.776V67.374H15.314a13.86,13.86,0,0,1,13.267-9.518h7.134V25.841Zm70.655-8.965h4.865v-4.8H84.393ZM46.716,8.146H89.258v-.96L46.716,3.925H40V57.856h4.8V10.109a1.963,1.963,0,0,1,1.963-1.963ZM99.757,61.781H28.581A10.46,10.46,0,0,0,18.543,69.8V70a.538.538,0,0,1,0,.183,1.435,1.435,0,0,1-.306.471.17.17,0,0,1-.1,0A1.346,1.346,0,0,1,17.6,71a2.1,2.1,0,0,1-.748.165H4.375v1.277H23.214a12.286,12.286,0,0,1,23.379,0H71.042a12.285,12.285,0,0,1,23.358,0h5.357ZM82.727,84.76A8.377,8.377,0,1,0,74.345,76.4a8.378,8.378,0,0,0,8.382,8.361m-48.043,0A8.377,8.377,0,1,0,26.3,76.4a8.364,8.364,0,0,0,8.382,8.361",
    transform: "translate(0)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27731",
    "data-name": "Path 27731",
    d: "M28.748,35.937h-5.4a1.963,1.963,0,0,1,0-3.925h5.4a1.963,1.963,0,0,1,0,3.925M80.226,52.7a5.669,5.669,0,1,1-4.038,1.667A5.71,5.71,0,0,1,80.226,52.7m0,7.474a1.777,1.777,0,0,0,1.667-1.094,1.787,1.787,0,1,0-3.433-.675,1.761,1.761,0,0,0,1.766,1.769M32.184,52.7a5.711,5.711,0,1,1-5.694,5.7,5.7,5.7,0,0,1,5.694-5.7m0,7.474a1.788,1.788,0,1,0-1.769-1.769,1.763,1.763,0,0,0,1.769,1.769M26.06,28.68H7.763A1.963,1.963,0,0,1,5.8,26.718V21.453A10.345,10.345,0,0,1,16.124,11.129H26.06a1.962,1.962,0,0,1,1.963,1.963V26.718A1.963,1.963,0,0,1,26.06,28.68M24.1,15.054H16.124a6.42,6.42,0,0,0-6.4,6.4v3.3H24.1Z",
    transform: "translate(2.5 17.994)",
    fill: "#d9000d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarsIcon);
export default __webpack_public_path__ + "static/media/cars_icon.dca0296111a173c05f8d6cf6d4a03763.svg";
export { ForwardRef as ReactComponent };